import React from 'react'
import SarasTrans from '../../../../library/notifications/SarasTrans';

//starting with capital letter will ensure this is treated as a component
const VoucherGridItemH = ({col}) => {

    return (
        <div className="uiSearchSubList">
            <span className="sItemID uiCenter"><SarasTrans value="Trans Id" /></span>
            <span className="sItemCode uiCenter"><SarasTrans value="Trans Date" /></span>
            <span className="sItemWeight uiCenter"><SarasTrans value="Days Overdue" /></span>
        </div>
    );
}

export default VoucherGridItemH
